import { Avatar, Box, Heading, Stack, Text } from '@chakra-ui/react'
import type { ReactElement } from 'react'

import { pluralize } from '@/utils/helpers'

import CourseQ from '@/queries/CourseQ'
import TopicQ from '@/queries/TopicQ'
import { useUser } from '@/client/context/user'
import type { Query } from '@/client/query'
import { getTopicUrlById } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import WideCardWithBezel from '@/components/UI/WideCardWithBezel'

export default function CourseTopicsList({ course }: { course: Query }): ReactElement {
  const user = useUser()
  const topics = course.many(
    TopicQ.where({ courseId: CourseQ.id, excludeChallenge: true, order: [[TopicQ.weight, 'desc']] })
  )
  const courseName = course(CourseQ.name) ?? ''

  return (
    <Stack direction="column" spacing={6} mt={8}>
      {topics.map(topic => {
        const topicName = topic(TopicQ.name) ?? ''
        const topicId = topic(TopicQ.id) ?? 0
        const topicIcon = topic(TopicQ.icon) ?? ''
        const numSessions = topic(TopicQ.countSessions(user.id)) ?? 0
        return (
          <ShwLink key={topicId} href={getTopicUrlById(topicId)} width="100%">
            <WideCardWithBezel clickable>
              <Stack direction="row" spacing={[5, 6]}>
                <Avatar
                  borderRadius="8px"
                  src={topicIcon}
                  name={topicName}
                  width="56px"
                  height="56px"
                />
                <Box>
                  <Text variant="eyebrow" mb={2}>
                    {courseName}
                  </Text>
                  <Heading size="xl">{topicName}</Heading>
                </Box>
              </Stack>
              <Box fontWeight="bold" display={['none', 'block']} color="fg.subtle">
                {pluralize(numSessions, 'Session')}
              </Box>
            </WideCardWithBezel>
          </ShwLink>
        )
      })}
    </Stack>
  )
}
